import { apiGet } from './client';

export function getMyAchievements() {
  return apiGet('/rewards');
}
